/**
 * Построение конфига узла для X6 (bounds, attrs, shape) и утилиты (kebabCase, icon path).
 */
import {toRgbaString} from '../draw/ArchimateRendererUtil';
import {nodeTypeRegistry} from '../node-types/NodeTypeRegistry';
import {AND_JUNCTION, OR_JUNCTION} from './constants';
import {getDefaultLabelForType, normalizeType} from './viewHelpers';

export const ICON_BOX_SIZE = 24;

const JUNCTION_TYPES = [AND_JUNCTION, OR_JUNCTION];

export function buildElementNodeConfig(
	modeler,
	type,
	{id, x, y, width, height, label, typeName, viewElement} = {}
) {
	const normalizedType = normalizeType(type);
	const nodeType = nodeTypeRegistry.get(normalizedType);
	if (!nodeType) {
		throw new Error(`Unsupported element type: ${normalizedType}`);
	}
	const labelToUse = JUNCTION_TYPES.includes(normalizedType)
		? ''
		: label != null && label !== ''
			? label
			: getDefaultLabelForType(modeler, normalizedType);
	const style = viewElement?.style;
	const useBackendColors = !JUNCTION_TYPES.includes(normalizedType);
	const fillFromStyle = style && (style.fillColor ?? style.get?.('fillColor'));
	const lineFromStyle = style && (style.lineColor ?? style.get?.('lineColor'));
	const fillColor = useBackendColors && fillFromStyle ? toRgbaString(fillFromStyle) : undefined;
	const lineColor = useBackendColors && lineFromStyle ? toRgbaString(lineFromStyle) : undefined;
	const textAlign = style?.textAlign ?? viewElement?.textAlign ?? null;
	const lineWidth = style?.lineWidth != null ? style.lineWidth : undefined;
	const config = nodeType.buildNodeConfig(modeler._pathMap, {
		id,
		x,
		y,
		width,
		height,
		label: labelToUse,
		fillColor,
		lineColor,
		textAlign,
		lineWidth,
		viewElement,
	});
	config.data = {
		...(config.data || {}),
		elementType: normalizedType,
		...(typeName != null && {typeName}),
	};
	return config;
}

export function toKebabCase(value) {
	return String(value)
		.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
		.replace(/\s+/g, '-')
		.toLowerCase();
}

export function getIconPath(modeler, iconKey, width, height) {
	const size = ICON_BOX_SIZE;
	const w = width != null && width > 0 ? width : size;
	const h = height != null && height > 0 ? height : size;
	return modeler._pathMap.getScaledPath(iconKey, {
		xScaleFactor: 1,
		yScaleFactor: 1,
		containerWidth: w,
		containerHeight: h,
		position: {mx: 0, my: 0},
	});
}
